import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { openInquiryPopup } from '../lib/contact';

export default function CTA() {
  return (
    <section id="services" className="py-24 relative overflow-hidden bg-primary">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-cover bg-center mix-blend-overlay"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=1600&q=80')" }} />
      <div className="container relative z-10 mx-auto px-4 md:px-8 text-center max-w-3xl">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6">Ready to Wear the White Coat?</h2>
        <p className="text-xl text-white/85 mb-10">
          Let our experienced counselors map out your journey. Free counseling, profile evaluation, and university selection tailored just for you.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={openInquiryPopup} data-testid="cta-free-counsel" size="lg" className="bg-brand text-white hover:bg-brand-dark font-bold px-8 h-14 text-base rounded-full btn-shift">Get Free Counseling</Button>
          <Link to="/services">
            <Button size="lg" variant="outline" className="border-white/40 bg-transparent text-white hover:bg-white hover:text-primary font-semibold h-14 px-8 rounded-full">How We Help</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
